import { render, staticRenderFns } from "./order-detail-unsubscribe.vue?vue&type=template&id=32d6c10f&scoped=true"
import script from "./order-detail-unsubscribe.vue?vue&type=script&lang=ts"
export * from "./order-detail-unsubscribe.vue?vue&type=script&lang=ts"
import style0 from "./order-detail-unsubscribe.vue?vue&type=style&index=0&id=32d6c10f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d6c10f",
  null
  
)

export default component.exports